<template>
  <v-card>
    <v-card-text>
      <px-contratacao-cpf-cnpj :contratacao="contratacao" ref="cpfCnpj"/>
      <px-contratacao-locais label="Endereço de coleta"
                             ref="coleta"
                             :show-divider="false"
                             :local="contratacao.coleta"/>
      <px-contratacao-locais label="Endereço de entrega"
                             :local="contratacao.entrega"
                             ref="entrega"/>
      <px-contratacao-dados-basicos :contratacao="contratacao"/>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary"
             :loading="loading"
             @click="onSave">
        Enviar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash';
import { onlyNumbers } from '@/utils/regex-utils';
import ContratacaoDadosBasicos from './ContratacaoDadosBasicos.vue';
import ContratacaoCpfCnpj from './ContratacaoCPFCNPJ.vue';
import ContratacaoLocais from './ContratacaoLocais.vue';
import ContratacaoFreteService from './contratacao-frete-service';

export default {
  props: {
    resposta: Object,
    cotacao: Object,
  },
  data() {
    return {
      loading: false,
      contratacao: {
        coleta: {
          cpfCnpj: null,
          cep: null,
          logradouro: null,
          numero: null,
          bairro: null,
          uf: null,
          municipio: null,
          complemento: null,
          pontoReferencia: null,
          favorito: false,
        },
        entrega: {
          cpfCnpj: null,
          cep: null,
          logradouro: null,
          numero: null,
          bairro: null,
          uf: null,
          municipio: null,
          complemento: null,
          pontoReferencia: null,
          favorito: false,
        },
        localPagamento: null,
        observacao: null,
        arquivos: [],
      },
    };
  },
  methods: {
    setupContratacao() {
      this.contratacao.coleta.cep = this.cotacao.cepColeta;
      this.contratacao.coleta.municipio = this.cotacao.municipioColeta;
      this.contratacao.coleta.uf = this.cotacao.municipioColeta.estado;
      // entrega
      this.contratacao.entrega.cep = this.cotacao.cepEntrega;
      this.contratacao.entrega.municipio = this.cotacao.municipioEntrega;
      this.contratacao.entrega.uf = this.cotacao.municipioEntrega.estado;
      this.contratacao.observacao = this.cotacao.observacao;

      // cpfCnpj
      this.contratacao.coleta.cpfCnpj = this.cotacao.cpfCnpjColeta;
      this.contratacao.entrega.cpfCnpj = this.cotacao.cpfCnpjEntrega;
      this.contratacao.localPagamento = this.cotacao.localPagamento;
    },
    isValid() {
      const isCpfCnpjValid = !this.$refs.cpfCnpj.validateForm();
      const isColetaValid = !this.$refs.coleta.validateForm();
      const isEntregavalid = !this.$refs.entrega.validateForm();
      return isCpfCnpjValid && isColetaValid && isEntregavalid;
    },
    buildPayload() {
      const contratacao = cloneDeep(this.contratacao);
      contratacao.coleta.cep = onlyNumbers(contratacao.coleta.cep);
      contratacao.coleta.cpfCnpj = onlyNumbers(contratacao.coleta.cpfCnpj);
      contratacao.entrega.cep = onlyNumbers(contratacao.entrega.cep);
      contratacao.entrega.cpfCnpj = onlyNumbers(contratacao.entrega.cpfCnpj);
      return contratacao;
    },
    onSave() {
      if (!this.isValid()) {
        return;
      }
      this.loading = true;
      ContratacaoFreteService.create(this.cotacao.id, this.resposta.id, this.buildPayload())
        .then(({ data }) => {
          this.$router.push({
            name: 'main.gestao-frete.contratacoes.detalhes',
            params: {
              id: data.id,
            },
          });
          this.$toast('Contratação enviada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.setupContratacao();
  },
  components: {
    pxContratacaoDadosBasicos: ContratacaoDadosBasicos,
    pxContratacaoCpfCnpj: ContratacaoCpfCnpj,
    pxContratacaoLocais: ContratacaoLocais,
  },
};
</script>
